/* RESPONSIBLE TEAM: team-proactive-support */
const MESSAGE_DATA_EXPORT_CONSTANTS = {
  folderExportType: 'folder',
};

export { MESSAGE_DATA_EXPORT_CONSTANTS };
